import { KuxFilteredCategoriesDTO } from '@kaltura-ott/tvpil';
import { observable } from 'mobx';

import { EntitiesType } from '../../../../entities';

import { CollectionRailStoreV2 } from './collection-rail-store-v2';

export class ManualCollectionRailStoreV2 extends CollectionRailStoreV2 {
  currentItems: EntitiesType[];
  protected _removeInvisible = false;

  @observable protected innerItems: EntitiesType[] = [];

  constructor(
    categoryTree: KuxFilteredCategoriesDTO,
    parentCategoryTree: KuxFilteredCategoriesDTO,
    items: EntitiesType[],
    children?: [],
  ) {
    super(categoryTree, parentCategoryTree, children);
    this.currentItems = items;
  }

  protected async getData(
    pageIndex: number,
    items: EntitiesType[],
  ): Promise<{ items: EntitiesType[]; totalCount: number; newItems: EntitiesType[] }> {
    this.innerItems.push(...this.currentItems);
    return { items: this.items as EntitiesType[], totalCount: this.innerItems.length, newItems: this.currentItems };
  }

  protected async getAdditionData(itemsInPage: EntitiesType[]): Promise<void> {
    return;
  }
}
